export default "__VITE_ASSET__6662e569__"